import React, { FC } from 'react'
import { CardContainer, CustomRound, CardText, CustomImage } from './styles'
import { PATH_TO_UNAVAILABLE_IMG } from '../../../../../constants/global'
import { Hidden } from '@hermes/web-components'

type RoundCardProps = {
  icon: string
  altIcon: string
  text: string
  gradient: string
  linkToRedirect: string
}

const RoundCard: FC<RoundCardProps> = ({
  icon,
  altIcon,
  text,
  gradient = 'linear-gradient(180deg, #FFD633 0%, #FFA19D 100%)',
  linkToRedirect
}) => {

  return (
    <CardContainer>
      <CustomRound gradient={gradient} onClick={() => window.location.assign(linkToRedirect)}>
        <Hidden smDown implementation="css">
          <CustomImage
            src={icon || altIcon || PATH_TO_UNAVAILABLE_IMG}
            isAltImage={!icon}
            width={78}
            height={78}
            alt="specialty"
          />
        </Hidden>
        <Hidden smUp implementation="css">
          <CustomImage
            src={icon || altIcon || PATH_TO_UNAVAILABLE_IMG}
            isAltImage={!icon}
            width={62}
            height={62}
            alt="specialty"
          />
        </Hidden>
      </CustomRound>
      <CardText href={linkToRedirect}>{text}</CardText>
    </CardContainer>
  )
}

export default RoundCard
